import { FC, useContext, useMemo, useRef } from "react";
import { expandCollapse } from "@app/shared/qes-standards/utility/expandCollapse";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESRadioButton } from "@app/shared/qes-standards/forms/RadioButton";
import { CreateExceptionsContext } from "@app/exceptions/contexts/CreateExceptionsContext";
import { CreateExceptionsState } from "@app/exceptions/interfaces";

interface StateAccordionProps {
  state: CreateExceptionsState;
}

const CreateExceptionsStateAccordionRadioButtons: FC<React.PropsWithChildren<StateAccordionProps>> = (props: StateAccordionProps) => {

  const wizardContext = useContext(CreateExceptionsContext);
  const countyListRef = useRef<HTMLUListElement>(null);
  const iconRef = useRef<HTMLButtonElement>(null);

  const handleOpen = () => {
    iconRef.current.style.transform = "rotate(90deg)";
  }

  const handleClose = () => {
    iconRef.current.style.transform = null;
  }

  const counties = useMemo(() => {
    return props.state.childServiceAreas.filter((child) => child.isVisible).map((child) => (
      <li key={child.displayName}>
        <QESRadioButton
          label={child.displayName}
          value={`${props.state.displayName}:${child.displayName}:${child.serviceAreaValue}`}
          checked={wizardContext.selectedServiceArea == `${props.state.displayName}:${child.displayName}:${child.serviceAreaValue}`}
          testId={`create-exceptions-wizard__county-radiobutton--${props.state.displayName}:${child.displayName}`}
          onClick={(e) => { e.stopPropagation(); }}
          onChange={() => wizardContext.updateSelectedServiceArea(props.state.displayName, child.displayName, child.serviceAreaValue)}
          onLabelClick={(e) => { e.stopPropagation(); }}
        />
      </li>
    ));
  }, [wizardContext, props]);

  return (
    <ul className="exceptions__wizard-state-list" onClick={() => { expandCollapse(countyListRef, handleClose, handleOpen); }}>
      <li>
        <QESButton
          className="vr__collapse-indicator"
          qesType="none"
          qesTestId={`vr__list-collapse-toggle--${props.state.displayName}`}
          onClick={(e) => e.preventDefault()}
          qesRef={iconRef}
        >
          <i className="fa fa-fw fa-chevron-right" />
        </QESButton>
        {props.state.displayName}
        <ul className="vr__list qes-js-closed exceptions__wizard-county" ref={countyListRef} onClick={(e) => { e.stopPropagation(); }}>
          {counties}
        </ul>
      </li>
    </ul>
  );
}

export default CreateExceptionsStateAccordionRadioButtons;